import { render, staticRenderFns } from "./FormTemplatePart.vue?vue&type=template&id=3c0c26ca&scoped=true&"
import script from "./FormTemplatePart.vue?vue&type=script&lang=js&"
export * from "./FormTemplatePart.vue?vue&type=script&lang=js&"
import style0 from "./FormTemplatePart.vue?vue&type=style&index=0&id=3c0c26ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0c26ca",
  null
  
)

export default component.exports